import { render, staticRenderFns } from "./sequence-review-associate-check.vue?vue&type=template&id=0a0a0a5a&scoped=true"
import script from "./sequence-review-associate-check.vue?vue&type=script&lang=js"
export * from "./sequence-review-associate-check.vue?vue&type=script&lang=js"
import style0 from "./sequence-review-associate-check.vue?vue&type=style&index=0&id=0a0a0a5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0a0a5a",
  null
  
)

export default component.exports